import styled from "styled-components";

export const PlayerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const ActionBar = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: #ffffff;
  color: #5a5a5a;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: #f5f5f5;
  }

  &:last-child {
    margin-left: auto;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e9ecef;
  margin: 10px 0;
`;
